import { RESERVATIONS_VIEW } from 'constants/permissions'
import { ReactLazyPreload } from 'utilities/PreloadLinks'

const Calendar = ReactLazyPreload(() => import('../components/Calendar'))

export const useRoutes = () => {
  return [
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      exact: true,
      permissions: [RESERVATIONS_VIEW],
    },
  ]
}
